import Model from './Model'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export default class Booking extends Model {
  resource() {
    return 'admin/bookings'
  }

  get addedDate() {
    return dayjs.utc(this.created_at).local().format('MMM DD, YYYY hh:mm A')
  }

  get bookedFrom() {
    return dayjs.utc(this.from).local().format('MMM DD, YYYY hh:mm A')
  }

  get bookedTo() {
    return dayjs.utc(this.to).local().format('MMM DD, YYYY hh:mm A')
  }

  get paidAt() {
    return dayjs.utc(this.paid_at).local().format('MMM DD, YYYY hh:mm A')
  }

  get readableType() {
    return this.type.replace('_', ' ')
  }
}
